import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import {
    Card,
    CardBody,
    Modal,
    ModalBody,
    Input,
    ModalHeader,
    Button,
    Row,
    Col,
    Label,
    FormFeedback,
    FormGroup,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import FabricTable from "./FabricTable"
import { dateFormat, dateTimeFormat, formatDateToISO } from "pages/Common"
import UpdateFabricModel from "./UpdateFabricModel"
import ErrorModel from "common/errorModel/errorModel"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"
import FabricCreateTable from "./FabricCreateTable"
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import Dropzone from "react-dropzone"
import uploadImage from "../../assets/images/uploadImage.png"
import Compressor from "compressorjs"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            border: "1px solid #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
            backgroundColor: isDisabled ? "#e9ecef" : "#fff",
            color: isDisabled ? "#6c757d" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            pointerEvents: isDisabled ? "none" : "auto",  // Important for full disabling
            opacity: isDisabled ? 0.6 : 1,
        };
    },
}



function FabricList() {
    document.title = `Requirements | Raja Rani Couture`
    let { pathname } = useLocation()
    let { state } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    // useStates
    const [modal, setModal] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [purchaseDoneModal, setPurchaseDoneModal] = useState(false)
    const [tableData, setTableData] = useState([]);
    const [tableDataInputFabric, setTableDataInputFabric] = useState(
        Array.from({ length: 10 }, () => ({
            Image: '',
            OrderNo: "",
            Name: "",
            DesignerBy: 0,
            Date: new Date(),
            Stuff: "",
        }))
    );
    const [fabricInputData, setFabricInputData] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [isEdit, setIsEdit] = useState(false)
    const [isCreate, setIsCreate] = useState(false)
    const [userData, setUserData] = useState([])
    const [editData, setEditData] = useState()
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(state == null ? true : false)
    const [isOrderComplete, setIsOrderComplete] = useState(false)
    const [isPurchaseComplete, setIsPurchaseComplete] = useState(false)
    const [TaskTitleTypes, setTaskTitleTypes] = useState(
        (JSON.parse(localStorage?.getItem("authUser")).TaskTitleTypes)
    )
    const [cost, setCost] = useState('')
    const [IsCostError, setIsCostError] = useState(false)
    const [fabricId, setFabricId] = useState(0)
    const [image, setImage] = useState('')
    const [srNo, setSrNo] = useState('')
    const [imageViewModal, setImageViewModal] = useState(false)

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                setUserData(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])


    // filter data for fabric
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // fabric list api
    const FabricListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Fabric/list", {
            UserId: parseInt(userFilter),
            isOrderComplete: isOrderComplete,
            isPurchaseComplete: isPurchaseComplete,
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data.FabricList)
                setTotalRecords(data.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // fabric list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            FabricListApi()
        }
    }, [searchText, displayStart, rowsPerPage, userFilter, dateDisble, dateFilter, isOrderComplete, isPurchaseComplete])

    // Create fabric handler
    const handleFabricClick = () => {
        toggle()
        setIsEdit(false)
        setIsCreate(true)
    }

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        // if (!modal) {
        //     setIsEdit(false)
        // }
    }

    const toggle1 = () => {
        setModal1(!modal1)
        setFabricInputData([])
        setTableDataInputFabric(Array.from({ length: 10 }, () => ({
            Image: '',
            OrderNo: "",
            Name: "",
            DesignerBy: 0,
            Date: new Date(),
            Stuff: "",
        })))
    }

    const purchaseDoneToggle = () => {
        setPurchaseDoneModal(!purchaseDoneModal)
        setCost('')
    }

    const handleEdit = (data) => {
        setEditData(data)
        setIsEdit(true)
        setIsCreate(false)
        toggle()
    }

    const handleDelete = (Id) => {
        setIsLoading(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this requirement permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Fabric/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Requirement deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Requirement",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }

    const MarkDoneOrderandPurchase = (Id, IsOrderDone) => {
        setformSumitLoading(true)
        DeleteModel.confirmDeleteInquiry({
            title: "Are you sure? ",
            text: "You want to mark this requirement done permanently? ",
            isMobile,
        }).then(response => {
            if (response == true) {
                postApi("Fabric/mark-as-done", {
                    Id: Id,
                    IsOrderDone: IsOrderDone,
                    Cost: parseFloat(cost || 0)
                }).then(
                    ({ data, status }) => {
                        if (status === 200) {
                            setformSumitLoading(false)
                            FabricListApi()
                            toast.success("Requirement done successfully", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            setformSumitLoading(false)
                            ErrorModel.errormodel({
                                title: "Verify Requirement",
                                text: data,
                            })
                        }
                        setIsLoading(false)
                    }
                )
            } else {
                setIsLoading(false)
            }
        })
    }

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const handleMarkDone = (Id, IsOrderDone) => {
        setIsLoading(true)
        setFabricId(Id)
        MarkDoneOrderandPurchase(Id, IsOrderDone)
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Image",
                accessor: "Image",
                width: "10%",
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-center">
                        {row.original?.Image ? (
                            <img
                                onClick={() => handleImageView(row.original.Image, row.original.OrderNo)}
                                src={row.original.Image}
                                alt="Requirement"
                                style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "6px" }}
                            />
                        ) : (
                            <span>N/A</span>
                        )}
                    </div>
                ),
            },
            {
                Header: "Sr. No",
                accessor: "OrderNo",
                width: "10%"
            },
            {
                Header: "Designer Name",
                accessor: "CreatedByName",
                width: "10%"
            },
            {
                Header: "Date",
                accessor: "Date",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.Date == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row.original?.Date.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Stuff",
                accessor: "Stuff",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0" style={{ textWrap: "wrap" }}>
                        {row.original?.Stuff == null
                            ? "N/A"
                            : row.original?.Stuff}
                    </p>
                ),
            },
            {
                Header: "Order Date",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Order Date
                    </div>
                ),
                accessor: "OrderDate",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {(row.original.OrderDate)
                            ?
                            dateFormat(row?.original?.OrderDate?.split("T")[0], "dd-MM-yyyy")
                            : (TaskTitleTypes?.includes("9")) ?
                                <>
                                    <div className="text-center">
                                        {row?.original?.PurchaseDate ?
                                            <Button
                                                color="primary"
                                                fabric="primary"
                                                className="btn btn-primary btn-sm "
                                                onClick={() => handleMarkDone(row.original.Id, true)}
                                            >
                                                Mark as Done
                                            </Button>
                                            :
                                            <Button
                                                color="secondary"
                                                fabric="secondary"
                                                className="btn btn-primary btn-sm"
                                                style={{ cursor: "not-allowed" }}
                                            >
                                                Mark as Done
                                            </Button>
                                        }
                                    </div>
                                </>
                                :
                                "N/A"}
                    </p >
                ),
            },
            {
                Header: "Created By",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CreatedByName}
                    </p>
                ),
            },
            {
                Header: "Purchase Date",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Purchase Date
                    </div>
                ),
                accessor: "PurchaseDate",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {(row.original.PurchaseDate)
                            ?
                            dateFormat(row?.original?.PurchaseDate?.split("T")[0], "dd-MM-yyyy")
                            : (TaskTitleTypes?.includes("10")) ?
                                <>
                                    <div className="text-center">
                                        <Button
                                            color="primary"
                                            fabric="primary"
                                            className="btn btn-primary btn-sm "
                                            onClick={() => handleMarkDone(row.original.Id, false)}
                                        >
                                            Mark as Done
                                        </Button>
                                    </div>
                                </>
                                :
                                "N/A"}
                    </p >
                ),
            },
            {
                Header: "Purchase By",
                accessor: "PurchaseByName",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.PurchaseByName || "N/A"}
                    </p>
                ),
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CreatedOn == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateFormat(row?.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "5%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            {row.original.OrderDate || row.original.PurchaseDate || TaskTitleTypes?.includes("10") ?
                                <li className="mytooltip">
                                    <i
                                        className=" fs-6 fas fa-edit btn-edit"
                                        id={`edittooltip${row.original.Id}`}
                                        style={{ cursor: "not-allowed", color: "#808080b3" }}
                                    ></i>
                                    <span className="mytext">Edit</span>
                                </li>
                                :
                                <li className="mytooltip">
                                    <i
                                        className=" fs-6 fas fa-edit btn-edit"
                                        onClick={() => handleEdit(row.original)}
                                        id={`edittooltip${row.original.Id}`}
                                    ></i>
                                    <span className="mytext">Edit</span>
                                </li>
                            }
                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDelete(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )

    const columns1 = useMemo(
        () => [
            {
                Header: "Image",
                Header: () => (
                    <div style={{ textAlign: "center" }}>Image</div>
                ),
                accessor: "Image",
                width: "3%",
                Cell: ({ row }) => (
                    <FormGroup>
                        <Dropzone
                            onDrop={async (acceptedFiles) => {
                                const selectedFile = acceptedFiles[0];
                                if (!selectedFile) return;

                                new Compressor(selectedFile, {
                                    quality: 0.4,
                                    success: async (compressedResult) => {
                                        const base64 = await toBase64(compressedResult);

                                        // Save both base64 and preview url in row
                                        handleInputChange(row.index, "Image", base64.split(",")[1]);
                                        handleInputChange(
                                            row.index,
                                            "PreviewUrl",
                                            URL.createObjectURL(compressedResult)
                                        );
                                    },
                                });
                            }}
                            multiple={false}
                        >
                            {({ getRootProps, getInputProps }) => (
                                <div
                                    className="d-flex flex-column align-items-center text-center"
                                    {...getRootProps()}
                                >
                                    <input {...getInputProps()} />

                                    {row.original.PreviewUrl ? (
                                        <div className="position-relative overflow-hidden product-image">
                                            <img
                                                style={{
                                                    cursor: "pointer",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "3px",
                                                }}
                                                width="45"
                                                height="50"
                                                src={row.original.PreviewUrl}
                                                alt="preview"
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                width: "45px",
                                                height: "50px",
                                                border: "1px solid #ced4da",
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "3px",
                                            }}
                                        >
                                            <img
                                                className="img-fluid"
                                                src={uploadImage} // placeholder
                                                alt="upload"
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </Dropzone>
                    </FormGroup>
                ),
            },
            {
                Header: "Sr. No",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Sr. No
                    </div>
                ),
                accessor: "OrderNo",
                width: "6%",
                Cell: ({ row }) => (
                    <Input
                        style={{ height: "27px" }}
                        placeholder="Sr. No"
                        value={row.original.OrderNo}
                        onChange={(e) =>
                            handleInputChange(row.index, "OrderNo", e.target.value)
                        }
                    />
                ),
            },
            {
                Header: "Designer Name",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Designer Name
                    </div>
                ),
                accessor: "Name",
                width: "18%",
                Cell: ({ row }) => (
                    <>
                        <FormGroup className="mb-2">
                            <Select
                                unstyled
                                styles={colourStyles}
                                value={userData.find(u => u.value === row.original.DesignerBy) || null}
                                onChange={(selected) => {
                                    handleInputChange(row.index, "DesignerBy", selected?.value);
                                    handleInputChange(row.index, "Name", selected?.label);
                                }}
                                options={userData}
                                className="select2-selection"
                            />
                        </FormGroup>
                    </>
                ),
            },
            {
                Header: "Date",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Date
                    </div>
                ),
                accessor: "Date",
                width: "8%",
                Cell: ({ row }) => (
                    <div className="d-flex date-after" >
                        <Flatpickr
                            className="form-control d-block flatpicker-date"
                            placeholder="dd-MM-yyyy"
                            options={{
                                // enableTime: true,
                                dateFormat: "d-m-Y",
                                disableMobile: true
                            }}
                            value={row.original.Date}
                            onChange={(e) =>
                                handleInputChange(row.index, "Date", e)
                            }
                        />
                    </div>
                ),
            },
            {
                Header: "Stuff",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Stuff
                    </div>
                ),
                accessor: "Stuff",
                width: "8%",
                Cell: ({ row }) => (
                    <Input
                        style={{ height: "27px" }}
                        placeholder="Stuff"
                        value={row.original.Stuff}
                        onChange={(e) =>
                            handleInputChange(row.index, "Stuff", e.target.value)
                        }
                    />
                ),
            },
        ],
        [userData]
    );

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const handleInputChange = (rowIndex, field, value) => {
        const updatedData = [...tableDataInputFabric];

        updatedData[rowIndex][field] =
            field === "Date" ? formatDateToISO(value) : value;

        setTableDataInputFabric(updatedData);

        const filteredData = updatedData.filter(row => row.OrderNo?.trim() !== "");
        setFabricInputData(filteredData);
    };


    const handleSubmitFabricData = () => {
        setformSumitLoading(true)
        postApi("Fabric/create", fabricInputData).then(({ data, status }) => {
            if (status = 200) {
                toast.success("Successfully Created", {
                    style: {
                        fontSize: "15px",
                    },
                })
                FabricListApi()
                setformSumitLoading(false)
                toggle1()
            } else {
                setformSumitLoading(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Order No.", "Designer Name", "Date", "Stuff", "Order Date", "Created By", "Purchase Date", "Purchase By", "Created On"];
            const mainTitle = "Requirements";
            const widthObj = [{
                Key: "A",
                Value: 12,
            },
            {
                Key: "B",
                Value: 20,
            },
            {
                Key: "C",
                Value: 15,
            },
            {
                Key: "D",
                Value: 18,
            },
            {
                Key: "E",
                Value: 15,
            },
            {
                Key: "F",
                Value: 12,
            },
            {
                Key: "G",
                Value: 20,
            },
            {
                Key: "H",
                Value: 15,
            },
            {
                Key: "I",
                Value: 15,
            },
            {
                Key: "J",
                Value: 18,
            },
            {
                Key: "K",
                Value: 20,
            },
            {
                Key: "L",
                Value: 15,
            },
            {
                Key: "M",
                Value: 15,
            },
            ]
            const extention = "Requirements.xlsx"
            let excelSheetData = []

            postApi("Fabric/list", {
                UserId: parseInt(userFilter),
                isOrderComplete: isOrderComplete,
                isPurchaseComplete: isPurchaseComplete,
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.FabricList.length; index++) {
                        let dataObj = {
                            OrderNo: data?.FabricList[index].OrderNo || "N/A",
                            Name: data?.FabricList[index].CreatedByName || "N/A",
                            Date: data?.FabricList[index].Date == "" || data?.FabricList[index].Date == null
                                ? "N/A"
                                : dateTimeFormat(data?.FabricList[index].Date, "dd-MM-yyyy"),
                            Stuff: data?.FabricList[index].Stuff || "N/A",
                            OrderDate: data?.FabricList[index].OrderDate == "" || data?.FabricList[index].OrderDate == null
                                ? "N/A"
                                : dateTimeFormat(data?.FabricList[index].OrderDate, "dd-MM-yyyy"),
                            CreatedByName: data?.FabricList[index].CreatedByName || "N/A",
                            PurchaseDate: data?.FabricList[index].PurchaseDate == "" || data?.FabricList[index].PurchaseDate == null
                                ? "N/A"
                                : dateTimeFormat(data?.FabricList[index].PurchaseDate, "dd-MM-yyyy"),
                            PurchaseByName: data?.FabricList[index].PurchaseByName || "N/A",
                            CreatedOn: data?.FabricList[index].CreatedOn == null
                                ? "N/A"
                                : dateFormat(data?.FabricList[index].CreatedOn, "dd-MM-yyyy"),
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })

            setIsLoading(false)
        }
    }

    const handleImageView = (Image, SrNo) => {
        setImage(Image)
        setSrNo(SrNo)
        imageViewToggle()
    }

    const imageViewToggle = () => {
        setImageViewModal(!imageViewModal)
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <FabricTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isFabricList={true}
                            handleFabricClick={handleFabricClick}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            users={users}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            writeDataToExcel={writeDataToExcel}
                            isPurchaseComplete={isPurchaseComplete}
                            setIsPurchaseComplete={setIsPurchaseComplete}
                            isOrderComplete={isOrderComplete}
                            setIsOrderComplete={setIsOrderComplete}
                            TaskTitleTypes={TaskTitleTypes}
                        />

                        {(isCreate || isEdit) &&
                            <UpdateFabricModel
                                modal={modal}
                                toggle={toggle}
                                isEdit={isEdit}
                                editData={isEdit ? editData : ''}
                                FabricListApi={FabricListApi}
                                AssignByData={''}
                                userData={userData}
                            />
                        }

                        <Modal
                            isOpen={modal1}
                            toggle={toggle1}
                            centered={true}
                            size="xl"
                            style={{ width: !isMobile ? "800px" : "" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={toggle1} tag="h5">
                                    {"Create Requirement"}
                                </ModalHeader>
                                <ModalBody>

                                    <FabricCreateTable
                                        columns={columns1}
                                        data={tableDataInputFabric}
                                        className="custom-header-css"
                                        isLoading={isLoading}
                                    />
                                    <Row>
                                        <Col style={{ display: "flex", justifyContent: "end" }} md={12}>
                                            {formSumitLoading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    fabric="primary"
                                                    className="btn btn-primary btn-sm "
                                                    // type="submit"
                                                    onClick={() => handleSubmitFabricData()}
                                                >
                                                    Save
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                </ModalBody>

                            </div>
                        </Modal >

                        <Modal
                            isOpen={purchaseDoneModal}
                            toggle={purchaseDoneToggle}
                            centered={true}
                            size="sm"
                        // style={{ width: !isMobile ? "1400px" : "" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={purchaseDoneToggle} >
                                    {"Purchase Done"}
                                </ModalHeader>
                                <ModalBody>
                                    <Row>
                                        <FormGroup className="mb-2">
                                            <Label className="form-label required">Cost</Label>
                                            <Input
                                                name="cost"
                                                className="form-control-sm"
                                                type="text"
                                                placeholder="Cost"
                                                value={cost}
                                                onKeyPress={handleKeyPress}
                                                onChange={(e) => setCost(e.target.value, setIsCostError(false))}
                                                invalid={IsCostError}
                                            />
                                            {IsCostError ? (
                                                <FormFeedback type="invalid">Cost is reuired</FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                    </Row>
                                    <Row>
                                        <Col style={{ display: "flex", justifyContent: "end" }} md={12}>
                                            {formSumitLoading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    fabric="primary"
                                                    className="btn btn-primary btn-sm "
                                                    // type="submit"
                                                    onClick={() => MarkDoneOrderandPurchase(fabricId, false)}
                                                >
                                                    Save
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                </ModalBody>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={imageViewModal}
                            toggle={imageViewToggle}
                            centered={true}
                            size="defualt"
                            style={{ width: isMobile ? "" : "500px" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={imageViewToggle} tag="h5">
                                    Sr. No: {srNo}
                                </ModalHeader>
                                <ModalBody>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <img
                                            style={{
                                                cursor: "pointer",
                                                border: "1px solid #ced4da",
                                                borderRadius: "3px",
                                            }}
                                            width="500px"
                                            height="550px"
                                            src={image}
                                        />
                                    </div>
                                </ModalBody>
                            </div>
                        </Modal >

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
FabricList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default FabricList
